module.exports = __webpack_public_path__ + "img/person-img3.9c3a39d1.png";